import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

interface IUseBgColor {
  bgColor: string;
}
interface IUseSysColor {
  sysColor: string;
}

interface DateProps extends IUseSysColor {
  children: string;
}

const flexDoubleCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewWrapper = styled.div`
  ${({ bgColor }: IUseBgColor) => css`
    width: 360px;
    box-shadow: 5px 5px 5px #e6e6e6;
    height: max-content;
    background-image: linear-gradient(180deg, ${bgColor}, #f7f7f7);
  `}
`;

export const AnnouncementTag = styled.div`
  ${({ bgColor }: IUseBgColor) => css`
    ${flexDoubleCenter};
    color: #ffffff;
    width: 50px;
    height: 25px;
    border-radius: 13px;
    font-weight: bold;
    margin-right: 17.5px;
    background-color: ${bgColor};
  `}
`;

export const NotificationTag = styled.div`
  ${({ sysColor }: IUseSysColor) => css`
    ${flexDoubleCenter};
    color: #ffffff;
    font-size: 15px;
    font-weight: bolder;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: ${sysColor};
  `}
`;

const DateDiv = styled.div`
  ${({ sysColor }: IUseSysColor) => css`
    ${flexDoubleCenter};
    color: #ffffff;
    width: 147px;
    height: 25px;
    border-radius: 13px;
    font-weight: bolder;
    background-color: ${sysColor};
  `}
`;

export const Date = ({ sysColor, children }: DateProps): JSX.Element => {
  return <DateDiv sysColor={sysColor}>{children}</DateDiv>;
};

export const BorderBar = styled.div`
  ${({ sysColor }: IUseSysColor) => css`
    ${flexDoubleCenter};
    width: 4px;
    height: 25px;
    border-radius: 2px;
    margin-right: 10px;
    background-color: ${sysColor};
  `}
`;
